import type { Document, DocumentType, User } from '@shared/schemas'
import type { PageProps, QueryDefinition } from '@/core'
import type { DocumentsFormValues } from './form'
import type { DocumentsVariables } from './variables'

export const DOCUMENTS_KEYS = {
  all: ['documents'],
  list: (type?: string) =>
    [...DOCUMENTS_KEYS.all, 'list', type || 'all'].join('/'),
  details: (id: string) => [...DOCUMENTS_KEYS.all, 'details', id].join('/'),
}

export type DocumentsQueryDefinition = [
  QueryDefinition<
    'documents',
    'query',
    { type?: DocumentType; agendaDate?: string } | void,
    Array<Document>
  >,
  QueryDefinition<'markAsRead', 'mutation', { id: string }, void>,
  QueryDefinition<'users', 'query', void, Array<User>>,
]

export const documentsQueries: NonNullable<
  PageProps<
    DocumentsFormValues,
    DocumentsQueryDefinition,
    DocumentsVariables
  >['queries']
> = [
  {
    key: 'documents',
    type: 'query',
    queryConfig: {
      queryKey: [DOCUMENTS_KEYS.list()],
      endpoint: ['api', 'documents'],
      enabled: true,
    },
  },
  {
    key: 'markAsRead',
    type: 'mutation',
    mutationConfig: {
      endpoint: ['api', 'documents/:id/read'],
      method: 'POST',
    },
  },
  {
    key: 'users',
    type: 'query',
    queryConfig: {
      queryKey: ['documents/users'],
      endpoint: ['api', 'users'],
      enabled: true,
    },
  },
]
